import { render, staticRenderFns } from "./TransferSettings.vue?vue&type=template&id=6e92a0b8&scoped=true"
import script from "./TransferSettings.vue?vue&type=script&lang=js"
export * from "./TransferSettings.vue?vue&type=script&lang=js"
import style0 from "./TransferSettings.vue?vue&type=style&index=0&id=6e92a0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92a0b8",
  null
  
)

export default component.exports